export const TC50 = "TUC 50";